import React from 'react';
import { Provider } from 'react-redux';
import store, { persistor } from './redux/store';
import { MainRoutes } from './navigation/config/Routes';
import ToastMessage from './components/atoms/ToastMessage';
import ThemeProvider from 'providers/ThemeProvider';
import AuthProvider from 'providers/AuthProvider';
import HostProvider from 'providers/HostProvider';
import MainMenuFloating from 'components/app_common/MainMenuFloating';
import AddNoteModalWrapper from 'components/app_common/AddNoteModal';
import SocketioProvider from './providers/SocketioProvider';
import QueryClientProvider from 'providers/QueryClientProvider';
import ToastifyProvider from 'providers/ToastifyProvider';
import { MessageNotification } from 'components/compounds/Chat';
import CapacitorProvider from 'providers/CapacitorProvider';
import FCMProvider from 'providers/FCMProvider';
import { Capacitor } from '@capacitor/core';

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider>
        <ThemeProvider>
          <AuthProvider>
            <SocketioProvider />
            <HostProvider>
              <MainRoutes />
            </HostProvider>
          </AuthProvider>
          <ToastMessage />
          <AddNoteModalWrapper />
          <MainMenuFloating />
        </ThemeProvider>
      </QueryClientProvider>
      <CapacitorProvider />
      <ToastifyProvider />
      <MessageNotification />
      {Capacitor.isNativePlatform() && <FCMProvider />}
    </Provider>
  );
};

export default App;
